import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2 } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostEmotionalDrainPart2KO() {
  const articleData = {
    title: '왜 어떤 사람들은 우리를 지치게 합니까? 2부',
    description: '에너지를 고갈시키는 더 미묘한 패턴. AI는 과도한 설명, 잘난 체하는 사람, 이모티콘 혼란 등을 감지합니다.',
    slug: 'emotional-drain-part-2',
    publishDate: '2025-11-16',
    author: 'Toxic Detector 편집팀'
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    datePublished: articleData.publishDate,
    author: {
      '@type': 'Organization',
      name: 'ToxicDetector'
    },
    publisher: {
      '@type': 'Organization',
      name: 'ToxicDetector'
    }
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText(window.location.href);
      alert('링크가 클립보드에 복사되었습니다!');
    }
  };
  return <>
      <MetaTags title="왜 어떤 사람들은 우리를 지치게 합니까? 2부 | ToxicDetector" description="에너지를 고갈시키는 더 미묘한 패턴. AI는 과도한 설명, 잘난 체하는 사람, 이모티콘 혼란 등을 감지합니다." keywords="감정적 소모, 에너지 뱀파이어, 유독한 관계, AI 분석" canonical={`https://toxicdetector.com/ko/blog/${articleData.slug}`} ogType="article" ogImage="https://toxicdetector.com/images/logo.png" schema={[articleSchema]} data-id="element-8103" data-mp="28hf14emajh20" />

      <div className="flex flex-col w-full min-h-screen bg-white" data-id="element-8104" data-mp="2w93vs1ml4hm4">
        <header className="bg-white/95 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50" data-id="element-8105" data-mp="2w799ojzkujgg">
          <div className="max-w-4xl mx-auto px-6 py-5" data-id="element-8106" data-mp="1ftj2v5h2ph34">
            <div className="flex items-center justify-between" data-id="element-8107" data-mp="1ku75ypiktodp">
              <Link to="/" className="flex items-center gap-2 group" data-id="element-8108" data-mp="1krkp1z9spwit">
                <span className="text-2xl" data-id="element-8109" data-mp="3ng2mt99bd06o">🚩</span>
                <span className="text-xl font-bold text-gray-900 group-hover:text-red-600 transition-colors" data-id="element-8110" data-mp="3igzkhwkpx82e">
                  ToxicDetector
                </span>
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-8111" data-mp="38rpuqndck1hg">
                <Share2 size={20} className="text-gray-600" data-id="element-8112" data-mp="33u6ddelcr8la" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-4xl mx-auto w-full px-6 py-16" data-id="element-8113" data-mp="2urx4et5qfna0">
          <Link to="/" className="inline-flex items-center text-gray-600 text-sm mb-12 hover:text-gray-900 transition-colors group" data-id="element-8114" data-mp="2usgke4bto1le">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-8115" data-mp="t0tq9twmvqkp" />
            홈으로 돌아가기
          </Link>

          <header className="mb-16" data-id="element-8116" data-mp="vl9qu80ssmfx">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 tracking-tight leading-[1.1] text-gray-900" data-id="element-8117" data-mp="vk8c9tkkphtg">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-500 text-sm gap-3" data-id="element-8118" data-mp="15b30v4lakti2">
              <time dateTime={articleData.publishDate} data-id="element-8119" data-mp="15d5nrfr5e6ik">
                {new Date(articleData.publishDate).toLocaleDateString('ko-KR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-8120" data-mp="hlh04cp9u67y">•</span>
              <span data-id="element-8121" data-mp="mk21wgk68xyi">{articleData.author}</span>
            </div>
          </header>

          <div className="prose prose-lg max-w-none" data-id="element-8122" data-mp="rj4ydcm35vuv">
            <p className="text-2xl mb-10 leading-relaxed text-gray-700 font-medium" data-id="element-8123" data-mp="rkprqywnz8r5">
              감정적 소모에 관한 시리즈 2부에 오신 것을 환영합니다. 1부에서는
              명백한 에너지 뱀파이어를 다루었습니다. 이제 더 미묘한 패턴에 대해
              자세히 알아보겠습니다.
            </p>

            <section className="mb-16" data-id="element-8124" data-mp="20jwtzixrzthg">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8125" data-mp="20ky3hiz587x2">
                1️⃣ 과도한 설명가
              </h2>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8126" data-mp="1wk4jh0otnd9g">
                간단한 질문에 소설로 답하고 불필요한 세부 사항으로 에너지를 묶는
                사람.
              </p>
            </section>

            <section className="mb-16" data-id="element-8127" data-mp="25hesefe62qb7">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8128" data-mp="2jir8qrx8otxm">
                2️⃣ 잘난 체하는 사람
              </h2>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8129" data-mp="2fhyx5s0wacy6">
                당신이 무슨 말을 하든, 이 사람은 더 잘 알고 있거나 더 나쁜
                경험을 했습니다. 고전적인 "One-Upper" 행동.
              </p>
            </section>

            <section className="mb-16" data-id="element-8130" data-mp="2oaiqqe2bxrc5">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8131" data-mp="2obkb5958jq6j">
                3️⃣ 이모티콘 혼란
              </h2>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8132" data-mp="2y7x1py5hhnx2">
                심각한 맥락에서 🙂 또는 🙃와 같은 수동적 공격적인 이모티콘을
                사용하여 혼란을 야기합니다.
              </p>
            </section>
          </div>

          <div className="bg-red-600 rounded-2xl p-12 md:p-16 text-center text-white shadow-xl mt-16" data-id="element-8133" data-mp="3lvk60ki00cn3">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight" data-id="element-8134" data-mp="37w2fo0p20rbm">
              에너지를 보호하세요.
            </h2>
            <p className="text-red-100 mb-10 text-xl leading-relaxed max-w-2xl mx-auto" data-id="element-8135" data-mp="3csj30sofj1nn">
              지치지 마세요. 당신에게 좋은 사람이 누구인지 알아보세요.
            </p>
            <Link to="/upload" className="inline-block bg-white text-red-600 px-12 py-5 rounded-xl font-bold text-lg hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl hover:scale-105" data-id="element-8136" data-mp="32wpv5mlnnwc7">
              지금 스캔하기 →
            </Link>
          </div>

          <div className="mt-20" data-id="element-8137" data-mp="2f6vesv24npn7">
            <RelatedBlogPosts posts={[{
            title: '왜 어떤 사람들은 우리를 지치게 합니까?',
            description: 'Toxic Detector의 AI가 일방적인 의사 소통을 감지하는 방법을 알아보세요.',
            slug: 'emotional-drain-relationships-ai',
            emoji: '😮‍💨'
          }, {
            title: '가스라이팅 징후 7가지',
            description: 'AI가 즉시 감지하는 가스라이팅 징후 7가지를 발견하세요.',
            slug: '7-signs-of-gaslighting',
            emoji: '💀'
          }]} data-id="element-8138" data-mp="2f7ws766m8o83" />
          </div>
        </article>

        <footer className="bg-gray-900 text-white py-16 mt-24" data-id="element-8139" data-mp="2f0uuqhyme5z8">
          <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-8140" data-mp="2f1e59dlxxs38">
            <p className="text-gray-400 text-sm" data-id="element-8141" data-mp="2a0yrwm1nskl9">
              © {new Date().getFullYear()} ToxicDetector. 전권 소유.
            </p>
          </div>
        </footer>
      </div>
    </>;
}